// hooks/useTonnagePanels.ts
import { useMemo } from 'react';
import { useTonnageStatsStore } from '../stores/tonnageStatsStore';
import { buildPanel, PanelData } from '../lib/tonnageAggregation';
import { getCurrentWeekNumber } from '../lib/dateHelpers';

export function useTonnagePanels(): { week: PanelData; month: PanelData; year: PanelData } {
    const {
        dataByYear, yearOne, yearTwo, weekOne, weekTwo, monthOne, monthTwo,
        selectedUnits, selectedAirlines,
    } = useTonnageStatsStore();

    const rowsY1 = dataByYear[yearOne] ?? [];
    const rowsY2 = dataByYear[yearTwo] ?? [];

    return useMemo(() => {
        const week = buildPanel(
            rowsY1, rowsY2,
            (r) => r.week === weekOne, (r) => r.week === weekTwo,
            selectedUnits, selectedAirlines
        );
        const month = buildPanel(
            rowsY1, rowsY2,
            (r) => r.month === monthOne, (r) => r.month === monthTwo,
            selectedUnits, selectedAirlines
        );
        const currentWeek = getCurrentWeekNumber();
        const year = buildPanel(
            rowsY1, rowsY2,
            (r) => r.week <= currentWeek, (r) => r.week <= currentWeek,
            selectedUnits, selectedAirlines
        );
        return { week, month, year };
    }, [rowsY1, rowsY2, weekOne, weekTwo, monthOne, monthTwo, selectedUnits, selectedAirlines]);
}